// /cms/alumni/unit/add
import request from "@/api/api";
// 保存单位信息（无 id 时按访客新增或更新最新一条；有 id 时须与访客标识一致方可更新）
export function addAlumniUnit(data) {
  return request({
    url: "/cms/alumni/unit",
    method: "post",
    data: data,
  });
}
// 查询当前访客的单位信息
export function getAlumniUnit(data) {
  return request({
    url: "/cms/alumni/unit",
    method: "get",
    params: data,
  });
}

// 保存个人信息（无 id 为新增；有 id 时须与访客标识一致方可更新）
export function addAlumniPersonal(data) {
  return request({
    url: "/cms/alumni/personal",
    method: "post",
    data: data,
  });
}

// 分页查询个人信息列表
export function getAlumniPersonalList(data) {
  return request({
    url: "/cms/alumni/personal/list",
    method: "get",
    params: data,
  });
}
// 查询个人信息详情
export function getAlumniPersonalDetail(id) {
  return request({
    url: "/cms/alumni/personal/" + id,
    method: "get",
  });
}
